<template>
  <div class="">
    <static-tabs-wallet active="contacts"> </static-tabs-wallet>
    <agency-contacts> </agency-contacts>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import AgencyContacts from "@/components/wallet/agency-contacts/index.vue";
import StaticTabsWallet from "@/components/wallet/static-tabs.vue";
export default {
  methods: {
    ...mapActions("queue", ["notifyQueue"]),
  },
  components: {
    AgencyContacts,
    StaticTabsWallet,
  },
  created() {
    this.notifyQueue({
      text: "Portafoglio",
      path: "",
      level: 1,
    });
    this.notifyQueue({
      text: "Contatti",
      path: "agency_contacts.index0",
      level: 2,
    });
  },
};
</script>
